// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Filter oprators enum.
 */
export enum FilterOperatorEnum {
  Or = 0,
  And = 1,
  None = 2
}
